import { CUSTOM_COLLECTION } from '../constants';

export const useCheckIfCustomCollection = (collectionId: string) => {
  return Object.values(CUSTOM_COLLECTION).includes(
    collectionId as CUSTOM_COLLECTION,
  );
};
